export default __webpack_public_path__ + "static/media/colors-2048w.76ea4143.webp";